import { StreamChunk } from '@/features/chat/types';

export interface StreamHandlerCallbacks {
    appendToStreamingMessage: (content: string) => void;
    finishStreamingMessage: () => void;
    updateMessageId: (oldId: string, newId: string) => void;
    setCurrentConversationId: (id: string) => void;
    onStreamingComplete?: (conversationId: string) => void;
}

export function createStreamHandler(
    messageId: string,
    conversationId: string | null,
    currentConversationId: string | null,
    callbacks: StreamHandlerCallbacks
) {
    const isNewConversation = !conversationId;
    let newConversationId: string | null = null;

    return (chunk: StreamChunk) => {
        // Track conversation ID for new conversations
        if (isNewConversation && chunk.conversation_id) {
            newConversationId = chunk.conversation_id;
        }

        switch (chunk.type) {
            case 'chunk':
            case 'content':
                if (chunk.content) {
                    callbacks.appendToStreamingMessage(chunk.content);
                }
                if (chunk.conversation_id && !currentConversationId) {
                    callbacks.setCurrentConversationId(chunk.conversation_id);
                }
                break;

            case 'error':
                console.error('Streaming error:', chunk.error);
                callbacks.appendToStreamingMessage(`\n\n[Error: ${chunk.error}]`);
                callbacks.finishStreamingMessage();
                break;

            case 'done':
                callbacks.finishStreamingMessage();
                if (chunk.metadata?.ai_message_id) {
                    callbacks.updateMessageId(messageId, chunk.metadata.ai_message_id);
                }
                // Trigger SSE for new conversations
                if (isNewConversation && newConversationId && callbacks.onStreamingComplete) {
                    callbacks.onStreamingComplete(newConversationId);
                }
                break;

            case 'metadata':
                break;

            default:
                console.warn('Unknown chunk type:', chunk);
        }
    };
}
